export const LOAD_EMPLOYEE_SATISFACTION_SURVEY = "LOAD_EMPLOYEE_SATISFACTION_SURVEY";
